import { useState } from "react";
import { SiteNav, SiteFooter } from "@/pages/LandingPage";
import { ChevronDown } from "lucide-react";

const faqs = [
  { q: "Who can join the pilot?", a: "Our pilot program is open to CSR teams from corporations looking to fund projects in Kerala, and grassroots NGOs operating in Kerala that meet our initial verification criteria. We are particularly interested in organizations focused on Healthcare, Education, Environment, and Livelihoods." },
  { q: "What sectors does ImpactX Bridge support?", a: "Initially, for our Kerala pilot, we are focusing on NGOs in Healthcare, Education, Environmental Sustainability, and Livelihood/Skill Development. As we expand, we aim to cover a broader range of social sectors." },
  { q: "Is there a fee to participate?", a: "For NGOs, onboarding and verification during the pilot phase are free. For CSR teams, we offer a tiered subscription model post-pilot, but pilot participation details will be discussed individually." },
  { q: "How does ImpactX Bridge ensure NGO credibility?", a: "We have a multi-stage verification process that includes checking legal registration (e.g., 12A, 80G, CSR-1), financial transparency, past project performance, and governance structures. We aim to provide a roster of 100% verified, impact-ready NGOs." },
  { q: "What kind of reporting does ImpactX Bridge offer?", a: "Our platform facilitates structured reporting from NGOs, including milestone updates, fund utilization reports, and impact metrics. For CSR teams, we provide consolidated, audit-friendly ESG reports and real-time project tracking dashboards." },
  { q: "What are the long-term aspirations for ImpactX Bridge?", a: "We're focused on building robust, scalable infrastructure for the social impact sector in India. Our ambition is to be the most trusted and efficient platform for CSR and NGO collaboration." },
  { q: "How does ImpactX Bridge distinguish itself?", a: "Key differentiators: India-first compliance-integrated approach, full-stack solution from NGO verification to ESG reporting, commitment to transparency, and upcoming AI/ML tools for intelligent matchmaking and risk scoring." },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <div className="min-h-screen bg-slate-50" data-testid="faq-page">
      <SiteNav />
      <main className="pt-16">
        <section className="py-20 px-6 bg-white">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-ix-red-600 mb-3">Support</p>
            <h1 className="text-3xl sm:text-4xl font-bold text-ix-black tracking-tight mb-8">Frequently Asked Questions</h1>
            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <div key={i} className="border border-slate-200 rounded-lg bg-white overflow-hidden" data-testid={`faq-item-${i}`}>
                  <button className="w-full flex items-center justify-between p-5 text-left" onClick={() => setOpen(open === i ? null : i)}>
                    <span className="text-sm font-semibold text-ix-black pr-4">{faq.q}</span>
                    <ChevronDown className={`w-4 h-4 text-slate-400 flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
                  </button>
                  {open === i && (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm text-slate-600 leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
